import { SECOND_IN_MS } from '@packages/shared/core/common/constants';

export const convertSecToMs = (sec = 0) => {
  return sec * SECOND_IN_MS;
};

export const convertMsToSec = (ms = 0) => {
  return ms / SECOND_IN_MS;
};
